import { MapsService } from './../../../services/maps/maps.service';
import { HostService } from './../../../services/host/host.service';
import { PdvService } from '@app/services/pdv/pdv.service';
import { Subscription } from 'rxjs';
import { Component, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { trigger, transition, group, query, animate, style } from '@angular/animations';
import { PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
declare var google;
@Component({
    selector: 'app-restaurant',
    templateUrl: 'restaurant.component.html',
    styleUrls: ['restaurant.component.scss'],
    animations: [
        trigger('zoomIn', [
            transition('* <=> *', [
                group([
                    query('.image', [
                        style({ opacity: 0, transform: 'translate(0,-100%)' }),
                    ], { optional: true }),
                    query('.comment', [
                        style({ opacity: 0, transform: 'translate(0,-10%)' }),
                    ], { optional: true }),

                    query('.livraison', [
                        style({ opacity: 0, transform: 'translate(0,-10%)' }),
                    ], { optional: true })
                ]),
                query('.image', [
                    animate('300ms ease-in', style({ opacity: 1, transform: 'translate(0,0)' }))
                ], { optional: true, delay: 100 }),
                query('.comment', [
                    animate('300ms ease-in', style({ opacity: 1, transform: 'translate(0,0)' }))
                ], { optional: true, delay: 100 }),
                query('.livraison', [
                    animate('300ms ease-in', style({ opacity: 1, transform: 'translate(0,0)' }))
                ], { optional: true, delay: 100 })
            ])
        ])
    ]
})
export class RestaurantComponent implements OnDestroy {
    pdv: any = {};
    host = '';
    imageSite: any;
    geocoder: any;
    infowindow: any;
    authorizedCities: any[];
    map: any;
    subscriptions: Subscription[] = [];
    @ViewChild('maplink') maplink: ElementRef
    displayAll = false;
    constructor(
        private pdvService: PdvService,
        private hostService: HostService,
        private maps: MapsService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.host = this.hostService.host2;
        this.getCities();
        const sub = this.pdvService.pdv.subscribe(pdv => {
            this.pdv = pdv;
            if (isPlatformBrowser(this.platformId)) {
                this.maps.doSomethingGoogley(pdv.maps).then(
                    (data: any) => {
                        this.geocoder = new google.maps.Geocoder();
                        this.infowindow = new google.maps.InfoWindow();
                        this.map = new google.maps.Map(document.getElementById('map'), { zoom: 11 });
                        this.geocoder.geocode({ 'address': this.pdv.address }, (results, status) => {
                            if (status === 'OK') {
                                this.map.setCenter(results[0].geometry.location);
                                const marker = new google.maps.Marker({
                                    position: results[0].geometry.location,
                                    map: this.map,
                                    icon: 'assets/images/icon2.png',
                                    title: this.pdv.name
                                });
                                marker.addListener('click', () => {
                                    this.infowindow.setContent('<span>' + this.pdv.address + '</span>');
                                    this.infowindow.open(this.map, marker);
                                });
                            }
                        });
                        this.setCities();
                    }
                );
            }
        }
        );
        this.subscriptions.push(sub);
    }

    getCities() {
        this.pdvService.getAuthorizedCities().toPromise().then(
            (authorizedCities: any[]) => {
                this.authorizedCities = authorizedCities;
            }
        );
    }
    setCities() {
        setTimeout(
            () => {
                if (this.geocoder) {
                    if (this.authorizedCities) {
                        this.authorizedCities.forEach((zone, i) => {
                            this.geocoder.geocode({ 'address': zone.name + ' ' + zone.postalCode, region: 'FR' }, (results, status) => {
                                if (status === 'OK') {
                                    this.map.setCenter(results[0].geometry.location);
                                    const marker = new google.maps.Marker({
                                        position: results[0].geometry.location,
                                        map: this.map,
                                        icon: 'assets/images/icon.png',
                                        title: this.pdv.name
                                    });
                                    marker.addListener('click', () => {
                                        // tslint:disable-next-line:max-line-length
                                        this.infowindow.setContent('<p><b>' + zone.name + ',' + zone.postalCode + '</b></p><span>Min de commande ' + zone.amountMiniDelivery + '€</span>');
                                        this.infowindow.open(this.map, marker);
                                    });
                                }
                            });
                        });
                    }
                }
            }, 1000
        );
    }

    onpenMarker({ target: marker }) {
        marker.nguiMapComponent.openInfoWindow('iw', marker);
    }

    onMarkerInit(event) {
        setTimeout(
            () => {
                event.nguiMapComponent.openInfoWindow('iw', event);
            }, 200
        );
    }

    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    ngOnDestroy() {
        this.unsubscribe();
    }

    ngOnInit() {
        setTimeout(
            () => {
                var coords = this.pdv.address;
                if (coords) {
                    coords = coords.replace(/\ /g, "+");
                    this.maplink.nativeElement.setAttribute("href", this.GetMapUrl(coords));
                }
            }, 500
        )
    }

    GetMapUrl(q) {
        if (isPlatformBrowser(this.platformId)) {
            var ua = navigator.userAgent.toLowerCase();
            var windows8 = ua.indexOf("windows nt 6.2") > -1
            var mobile = ua.indexOf("mobile") > -1 || ua.indexOf("wp7") > -1;
            var iPhone = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
            var android = ua.indexOf("android") > -1;
            var msie = ua.indexOf("msie") > -1;
            if (mobile && iPhone) return ("http://maps.google.com/maps?q=" + q);
            else if (mobile && android) return ("geo:0,0?q=" + q);
            else if (mobile && msie) return ("maps:" + q);
            else if (windows8) return ("bingmaps:?q=" + q); else
                return ("http://maps.google.com/maps?q=" + q);
        }
    }

}
